(function () {
  function initializeParallax() {
    if (!window.SimpleParallax) return;

    const images = document.querySelectorAll(
      '.shopify-section.parallax img.inner:not([data-simple-parallax])'
    );

    if (!images.length) return;

    new window.SimpleParallax(images, {
      delay: 0.2,
      orientation: 'up',
      scale: 1.2,
      overflow: false,
    });

    images.forEach((image) => image.setAttribute('data-simple-parallax', 'true'));
  }

  initializeParallax();
  document.addEventListener('shopify:section:load', initializeParallax);
})();
